export default __webpack_public_path__ + "static/media/studio-4.becc1df1.png";